import jwtDecode from 'jwt-decode'
import { MagicLinkJwt } from '../auth-types'
import { isoToBrazilianDate } from '@/utils/date'

class GetAuthMagicLinkByAccount {
  private decodeData(token: string) {
    return jwtDecode<MagicLinkJwt>(token)
  }

  toDomain(token: string) {
    const decodedData = this.decodeData(token)
    return {
      cpf: decodedData?.cpf,
      idAccount: Number(decodedData?.conta_id),
      name: decodedData?.nome,
      email: decodedData?.email,
      cellphone: decodedData?.telefone,
      birthDate: isoToBrazilianDate(decodedData?.data_nascimento),
      hasPatient: decodedData?.existe_paciente,
      token: token,
    }
  }
}

export default new GetAuthMagicLinkByAccount()
